export const Grabber = () => (
  <svg width="16" height="26" viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle className="grabber-circle" cx="3" cy="3" r="3" fill="#96969C" />
    <circle className="grabber-circle" cx="13" cy="3" r="3" fill="#96969C" />
    <circle className="grabber-circle" cx="3" cy="13" r="3" fill="#96969C" />
    <circle className="grabber-circle" cx="13" cy="13" r="3" fill="#96969C" />
    <circle className="grabber-circle" cx="3" cy="23" r="3" fill="#96969C" />
    <circle className="grabber-circle" cx="13" cy="23" r="3" fill="#96969C" />
  </svg>
);
